import { jsx as _jsx } from "react/jsx-runtime";
import * as S from './ToastProvider.css';
const ToastProvider = () => {
    return (_jsx("div", { children: _jsx(S.Toast, { autoClose: 20000, hideProgressBar: true }) }));
};
export default ToastProvider;
